import { render } from "./DatePickerPage.vue?vue&type=template&id=71dd4ac6&scoped=true"
import script from "./DatePickerPage.vue?vue&type=script&lang=js"
export * from "./DatePickerPage.vue?vue&type=script&lang=js"

import "./DatePickerPage.vue?vue&type=style&index=0&id=71dd4ac6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dd4ac6"]])

export default __exports__